export enum OasisExportBatchStatusEnum {
  Pending = 1,
  Success = 2,
  PartialSomeFailures = 3,
  Failed = 4,
  ResultsUploaded = 5
}

export const OasisExportBatchStatusOptions = [
{ id: 1, label: 'Pending' },
{ id: 2, label: 'Success' },
{ id: 3, label: 'Partial - Some Failures' },
{ id: 4, label: 'Failed' },
{ id: 5, label: 'Results Uploaded' }
];
